import { EnumOption } from "./enum-option"

export const CompanyAddressType = {
    HQ: 0,    
    Worksite: 1, 
    Mail: 2, 
    Remote: 3, 
    FNResidentialOrWorkFromHome: 4, 
    ThirdParty:5
}

export const CompanyAddressTypeList: EnumOption[] = [
    { value: CompanyAddressType.HQ, label: 'HQ' },    
    { value: CompanyAddressType.Worksite, label: 'Worksite' },
    { value: CompanyAddressType.Mail, label: 'Mailing' },
    { value: CompanyAddressType.Remote, label: 'Remote' },
    { value: CompanyAddressType.FNResidentialOrWorkFromHome, label: 'FN Residential / WFH' },
    { value: CompanyAddressType.ThirdParty, label: '3rd Party' },
]
